@import '../../../theme.scss';

verdocs-download-dialog {
  box-sizing: border-box;
  font-family: $primary-font;

  .heading-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 0 24px 20px 24px;
  }

  .download-option {
    display: flex;
    align-items: center;
    padding: 12px 15px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    gap: 15px;
    background: white;

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;

      &:hover {
        background-color: white;
        border-color: #e5e7eb;
      }
    }

    &:hover {
      border-color: $verdocs-primary-color;
      background-color: #f9fafb;
    }
  }

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background-color: #f3f4f6;
    border-radius: 50%;
    color: #4b5563;
    flex-shrink: 0;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  .text-container {
    flex: 1;

    .label {
      font-weight: 500;
      color: #111827;
      margin-bottom: 2px;
    }

    .description {
      font-size: 13px;
      color: #6b7280;
    }
  }

  .status-indicator {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    font-size: 11px;
    color: #9ca3af;
    min-width: 50px;

    .signed {
      color: #10b981;
    }

    .spinner-inline {
      display: flex;
      color: #9ca3af;
      animation: rotate 2s linear infinite;
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }

  .info-message {
    font-size: 13px;
    color: #6b7280;
    font-style: italic;
    padding: 0 4px;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
